import { type ComponentType, type LazyExoticComponent, lazy } from 'react';

import { loadChunkInBackground } from './reloadOnMissingChunk.ts';

// The constraint mirrors React.lazy's own signature (ComponentType<any>) so T infers as the
// full component type. A narrower constraint makes contravariant props inference collapse
// the props type to `never`.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithPreload<T extends ComponentType<any>>(
    factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> & { preload: () => void } {
    // lazy() + a preload() that reuses the same import(). import() is idempotent, so the
    // idle prefetch and the eventual render share one network request.
    const Component = lazy(factory) as LazyExoticComponent<T> & { preload: () => void };
    Component.preload = () => void loadChunkInBackground(factory);
    return Component;
}
